import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';

Vue.use(Vuex);

const state = {
  auctionsCatalog: {},
  artworks: {},
  meta: {},
  userId: null,
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/store/index.js